$('#SiteNav .site-nav__link--button').hover(
  function () {
    $(this).click(); 
    ///$(this).parent().addClass("site-nav--active-dropdown");
    //$(this).attr('aria-expanded', 'true');
    console.log(1111);
  },
  function () {
    //$(this).click(); 
    //  $(this).parent().removeClass("site-nav--active-dropdown");
    // $(this).attr('aria-expanded', 'false');
    console.log(222);
  }
);


$(document).ready(function() {
  var s = $("#AccessibleNav");
  var pos = s.position();   				    
  $(window).scroll(function() {
    var windowpos = $(window).scrollTop();
    if (windowpos >= pos.top) {
      s.addClass("sticky");
    } else {
      s.removeClass("sticky");    
    }
  });
});
